import React from "react";

export const Middle = () => {
  return (
    <div className="py-6 grid grid-cols-2 md:grid-cols-3 md:gap-12  w-auto">
      <div className="">
        <h1 class="text-xl pb-3">Resources</h1>
        <ul class="leading-8">
          <li>Pricing</li>
          <li><a href="/Pages/Blog">Blog</a></li>
          <li>Advertise</li>
          <li>Support</li>
        </ul>
      </div>
      <div>
        <h1 className="text-xl pb-3">Useful Info</h1>
        <ul className="leading-8">
          <li>Terms of Service</li>
          <li>Privacy Policy</li>
          <li><a href="/Pages/faq">FAQ</a></li>
          <li>We use cookies</li>
        </ul>
      </div>
      <div>
        <h1 className="text-xl pb-3 pt-4 md:pt-0">Company</h1>
        <ul className="leading-8">
          <li>About Us</li>
          <li>Careers</li>
          <li>Support</li>
          <li>Contact Us</li>
        </ul>
      </div>
    </div>
  );
};
